import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { CustomerService, SalesInqueryService } from '../../../services';
import { PackingDetails, ProductFeature, SalesInqueryBreackdown } from 'src/app/core/types';
import { NotificationService } from '../../notification/notification.service';
import { ComboboxSelections, CompanyDetails } from 'src/app/core/shared-data';

@Component({
  selector: 'app-sales-inquery-pdf',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sales-inquery-pdf.component.html',
  styleUrls: ['./sales-inquery-pdf.component.scss']
})
export class SalesInqueryPdfComponent {
  @ViewChild('pdfContainer') pdfContainer!: ElementRef;
  @Output() closebtnEvent = new EventEmitter<boolean>();

  constructor(
    private salesInqueryService: SalesInqueryService,
    private customerService: CustomerService,
    private notificationService: NotificationService,
    private companyDetails: CompanyDetails,
    private comboboxSelections: ComboboxSelections,

  ) { }

  ngOnInit() {
    let si_id = sessionStorage.getItem("si_id")
    if (si_id) {
      this.getSalesInqueryById(si_id)
    } else {
      this.notificationService.Error("Session read failed", "Unexpected Error")
    }
  }

  pdfVariables = {
    companyDetails: this.companyDetails.getCompanydetails(),
    inqueryType: "",
    customerName: "",
    customerDetails: {
      addressLineOne: "",
      addressLineTwo: "",
      addressLineThree: "",
      city: "",
      country: "",
      contact: "",
    },
    inqueryInfo: {
      number: "",
      date: "",
      salesPerson: "",
    },
    descriptionHesders: {
      jobTitle: "",
      noOfColors: 0,
      orderType: "",
      // new: "Error",
      // repeat: "",
      board: "ERROR",
      totalQty: 1,
      tiep: "",
      fsc: "",
      ctnSize: "",
      lengthUnit: "",
      remarks: ""
    },
    tblItems: Array(),
    book: {
      coverPage: "",
      innerPage: "",
      innerPages: 0,
      coverPages: 0
    },
    finishings: [""]
  }


  getSalesInqueryById(id: string) {
    this.salesInqueryService.getSalesInqueryById(id).subscribe(
      (response) => {
        console.log(response);
        let data = response.data

        try {
          this.pdfVariables.customerName = data.customer.customerName

          this.pdfVariables.inqueryType = data.product_type.productTypeName
          Object.assign(this.pdfVariables.customerDetails, data.customerAddress)
          this.getCustomerById(data.customer.customerId)

          this.pdfVariables.inqueryInfo.number = data.sales_inquiry_number
          this.pdfVariables.inqueryInfo.date = data.sales_inquiry_date
          this.pdfVariables.inqueryInfo.salesPerson = data.salesPerson?.employeeName ?? "Errorr"

          this.pdfVariables.descriptionHesders.jobTitle = data.sales_inquiry_tile

          let productFeatures: ProductFeature = JSON.parse(data.product_features)
          console.log(data.product_features);
          console.log(productFeatures.productFeatureSpecs);
          console.log(productFeatures.productFinishings);

          this.pdfVariables.descriptionHesders.tiep = productFeatures.productFeatureSpecs.tiep ? "Yes" : "No"
          this.pdfVariables.descriptionHesders.fsc = productFeatures.productFeatureSpecs.fsc ? "Yes" : "No"

          if (productFeatures.productFeatureSpecs.fscType) {
            const fscName = this.comboboxSelections.fsc.find(f => f.id === +(productFeatures.productFeatureSpecs.fscType ?? 0))
            if (fscName) {
              this.pdfVariables.descriptionHesders.fsc = fscName.name
            }
          }
          
          this.pdfVariables.descriptionHesders.noOfColors = productFeatures.productFeatureSpecs.noOfColors ?? 0

          this.pdfVariables.finishings = productFeatures.productFinishings.map(item => item.productFeatureCode)

          this.pdfVariables.book.coverPage = productFeatures.productFeatureSpecs.book_coverPageMaterial ?? ""
          this.pdfVariables.book.innerPage = productFeatures.productFeatureSpecs.book_innerPageMaterial ?? ""
          // this.pdfVariables.book.pages = (productFeatures.productFeatureSpecs.book_noOfInnerPages ?? 0) + (productFeatures.productFeatureSpecs.book_noOfCoverPages ?? 0)
          this.pdfVariables.book.innerPages = productFeatures.productFeatureSpecs.book_noOfInnerPages ?? 0
          this.pdfVariables.book.coverPages = productFeatures.productFeatureSpecs.book_noOfCoverPages ?? 0

          this.pdfVariables.descriptionHesders.board = productFeatures.productFeatureSpecs.board ?? ""
          this.pdfVariables.descriptionHesders.orderType = productFeatures.productFeatureSpecs.orderType ?? ""

          this.pdfVariables.descriptionHesders.remarks = data.sales_inquiry_remarks ?? ""

          if (data.product_type.productTypeId == 3 || data.product_type.productTypeId == 7) {
            this.pdfVariables.descriptionHesders.ctnSize = `${productFeatures.productFeatureSpecs.book_coverPageDimentions ?? ""} & ${productFeatures.productFeatureSpecs.book_innerPageDimentions ?? ""}`
            this.pdfVariables.descriptionHesders.lengthUnit = productFeatures.productFeatureSpecs.dimention_unit ?? ""
          } else {
            this.pdfVariables.descriptionHesders.ctnSize = productFeatures.productFeatureSpecs.dimention ?? ""
            this.pdfVariables.descriptionHesders.lengthUnit = productFeatures.productFeatureSpecs.dimention_unit ?? ""
          }
        } catch (error) {
          console.log(error);
        }

        let totalBreackdownQuantity = 0
        if (data.sales_inquiry_breakdowns) {
          for (let item of data.sales_inquiry_breakdowns) {
            let breackdown: SalesInqueryBreackdown = item

            let packingDetails: PackingDetails = JSON.parse(breackdown.packingDetails)
            console.log(packingDetails)

            let productDetails = JSON.parse(breackdown.productDetails)
            let TableItem = {
              description: breackdown.description ?? "",
              orderNo: productDetails.orderNo ?? "",
              quantity: breackdown.quantity ?? 0,
              packingDate: productDetails.packingDate ?? "",
              expieryDate: productDetails.expiryDate ?? "",
              batchNo: productDetails.batchNo ?? "",
              itemNo: productDetails.productCode ?? ""
            }
            this.pdfVariables.tblItems.push(TableItem)

            totalBreackdownQuantity = totalBreackdownQuantity + +breackdown.quantity
          }
        }
        this.pdfVariables.descriptionHesders.totalQty = totalBreackdownQuantity

      },
      (error) => {
        console.log(error);
      }
    )
  }

  getCustomerById(id: number) {
    this.customerService.getCustomerById(id.toString()).subscribe(
      (response) => {
        this.pdfVariables.customerDetails.contact = response.data.telephoneNo
      }, (error) => {
        console.log(error);

      }
    )
  }

  convertToPDF() {
    let pdfName = `sales_inquery-${this.pdfVariables.inqueryInfo.number}`

    var data = document.getElementById('contentToConvert');
    if (data) {
      html2canvas(data, { scale: 3 }).then(canvas => {
        // Few necessary setting options
        var imgWidth = 210;
        var pageHeight = 297;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png');
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
        var position = 0;
        // pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight, '', 'SLOW');
        pdf.save(pdfName); // Generated PDF
      });
    }
  }

  closePdf() {
    this.closebtnEvent.emit(true);
  }

  // Function to convert data URL to Blob
  dataURLtoBlob(dataURL: any) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }


  // convertToPDF() {
  //   let pdfName = `sales_inquery-${this.pdfVariables.inqueryInfo.number}`

  //   var data = document.getElementById('contentToConvert');
  //   if (data) {
  //     html2canvas(data, { scale: 3 }).then(canvas => {
  //       console.log(canvas);
  //       // Few necessary setting options
  //       var imgWidth = 210;
  //       var pageHeight = 297;
  //       var imgHeight = canvas.height * imgWidth / canvas.width;
  //       var heightLeft = imgHeight;

  //       const contentDataURL = canvas.toDataURL('image/png');
  //       // Optimize image using compressorjs
  //       // Convert data URL to Blob
  //       const blob = this.dataURLtoBlob(contentDataURL);

  //       new Compressor(blob, {
  //         quality:0.5,
  //         maxWidth: 800,
  //         maxHeight: 600,
  //         success(result) {
  //           const compressedDataURL = URL.createObjectURL(result);
  //           // result is the compressed data URL
  //           // Create a new jsPDF instance
  //           let pdf = new jspdf('p', 'mm', [imgWidth, imgHeight]);

  //           // Add the optimized image to the PDF
  //           pdf.addImage(compressedDataURL, 'PNG', 0, 0, imgWidth, imgHeight);

  //           // Save the generated PDF with the specified name
  //           pdf.save(pdfName);
  //         },
  //         error(e) {
  //           console.error(e.message);
  //         },
  //       });
  //     });
  //   }
  // }

  @ViewChild('pdfPage') pdfPage!: ElementRef;

  zoomLevel = 1;

  zoomIn() {
    this.zoomLevel += 0.1;
    this.applyZoom(this.zoomLevel);
  }

  zoomOut() {
    this.zoomLevel -= 0.1;
    this.applyZoom(this.zoomLevel);
  }

  applyZoom(zoomLevel: number) {
    const el = this.pdfPage.nativeElement;
    el.style.transform = `scale(${zoomLevel})`;
  }
}

